"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/nl-NL.ts
var nl_NL_exports = {};
__export(nl_NL_exports, {
  AG_CHARTS_LOCALE_NL_NL: () => AG_CHARTS_LOCALE_NL_NL
});
module.exports = __toCommonJS(nl_NL_exports);
var AG_CHARTS_LOCALE_NL_NL = {
  ariaAnnounceChart: "grafiek, ${seriesCount}[number] reeksen",
  ariaAnnounceFlowProportionLink: "link ${index} van ${count}, van ${from} naar ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "knooppunt ${index} van ${count}, ${description}",
  ariaAnnounceGaugeChart: "meterdiagram, ${caption}",
  ariaAnnounceHierarchyChart: "hi\xEBrarchie diagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niveau ${level}[number], ${count}[number] kinderen, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Druk op Spatie of Enter om zichtbaarheid te wisselen",
  ariaLabelAddHorizontalLine: "Horizontale Lijn Toevoegen",
  ariaLabelAnnotationOptionsToolbar: "Annotatie-opties",
  ariaLabelAnnotationSettingsDialog: "Annotatie-instellingen",
  ariaLabelColorPicker: "Kleurkiezer",
  ariaLabelFinancialCharts: "Financi\xEBle grafieken",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Legenda-item ${index}[number] van ${count}[number]",
  ariaLabelLegendItemUnknown: "Onbekend legende-item",
  ariaLabelLegendPageNext: "Volgende Legend Pagina",
  ariaLabelLegendPagePrevious: "Vorige Legenda Pagina",
  ariaLabelLegendPagination: "Legenda Paginering",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Bereik",
  ariaLabelRangesToolbar: "Bereiken",
  ariaLabelSettingsTabBar: "Instellingen",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] tot ${max}[percent0to2dp]",
  contextMenuDownload: "Downloaden",
  contextMenuPanToCursor: "Naar hier pannen",
  contextMenuToggleOtherSeries: "Andere series in-/uitschakelen",
  contextMenuToggleSeriesVisibility: "Zichtbaarheid Wijzigen",
  contextMenuZoomToCursor: "Hier inzoomen",
  dialogHeaderChannel: "Kanaal",
  dialogHeaderDatePriceRange: "Datum en Prijs",
  dialogHeaderDateRange: "Datumbereik",
  dialogHeaderFibonacciRange: "Fib Retracement",
  dialogHeaderLine: "Lijn",
  dialogHeaderPriceRange: "Prijsklasse",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Uitlijnen",
  dialogInputColorPicker: "Kleur",
  dialogInputColorPickerAltText: "Tekstkleur",
  dialogInputExtendAbove: "Boven uitbreiden",
  dialogInputExtendBelow: "Naar beneden uitbreiden",
  dialogInputExtendChannelEnd: "Kanaaleinde uitbreiden",
  dialogInputExtendChannelStart: "Kanaalstart verlengen",
  dialogInputExtendLeft: "Links uitbreiden",
  dialogInputExtendLineEnd: "Verleng lijneinde",
  dialogInputExtendLineStart: "Lijnbegin verlengen",
  dialogInputExtendRight: "Naar rechts uitbreiden",
  dialogInputFibonacciBands: "Banden",
  dialogInputFibonacciBandsAltText: "Fibonacci Banden",
  dialogInputFillColorPicker: "Vul",
  dialogInputFillColorPickerAltText: "Vulkleur",
  dialogInputFontSize: "Grootte",
  dialogInputFontSizeAltText: "Lettergrootte",
  dialogInputLineStyle: "Streep",
  dialogInputPosition: "Positie",
  dialogInputReverse: "Omkeren",
  dialogInputShowFill: "Inkleuren weergeven",
  dialogInputStrokeWidth: "Gewicht",
  dialogInputStrokeWidthAltText: "Lijndikte",
  iconAltTextAlignCenter: "Centreren",
  iconAltTextAlignLeft: "Links",
  iconAltTextAlignRight: "Rechts",
  iconAltTextClose: "Sluiten",
  iconAltTextLineStyleDashed: "Lang-gestreept",
  iconAltTextLineStyleDotted: "Kort-gestreept",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Onderkant",
  iconAltTextPositionCenter: "Midden",
  iconAltTextPositionTop: "Boven",
  inputTextareaPlaceholder: "Voeg Tekst Toe",
  measurerDateRangeBars: "${value}[number] staven",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volume ${value}",
  overlayLoadingData: "Gegevens laden...",
  overlayNoData: "Geen gegevens om weer te geven",
  overlayNoVisibleSeries: "Geen zichtbare reeks",
  overlayUnsupportedBrowser: "Ongeschikte browserversie. Gelieve uw browser te updaten.",
  seriesHistogramTooltipCount: "${yName} (aantal)",
  seriesHistogramTooltipFrequency: "Frequentie",
  seriesHistogramTooltipMean: "${yName} (gemiddelde)",
  seriesHistogramTooltipSum: "${yName} (som)",
  toolbarAnnotationsArrow: "Pijl",
  toolbarAnnotationsArrowDown: "Pijl Omlaag",
  toolbarAnnotationsArrowUp: "Pijl Omhoog",
  toolbarAnnotationsCallout: "Tekstballon",
  toolbarAnnotationsClearAll: "Alles wissen",
  toolbarAnnotationsComment: "Opmerking",
  toolbarAnnotationsDatePriceRange: "Datum en Prijs",
  toolbarAnnotationsDateRange: "Datumbereik",
  toolbarAnnotationsDelete: "Verwijderen",
  toolbarAnnotationsDisjointChannel: "Niet-overlappend kanaal",
  toolbarAnnotationsDragHandle: "Sleepwerkbalk",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Gebaseerd",
  toolbarAnnotationsFillColor: "Vulkleur",
  toolbarAnnotationsHorizontalLine: "Horizontale lijn",
  toolbarAnnotationsLineAnnotations: "Trendlijnen",
  toolbarAnnotationsLineColor: "Lijnkleur",
  toolbarAnnotationsLineStrokeWidth: "Lijnstreepdikte",
  toolbarAnnotationsLineStyle: "Lijnstijl",
  toolbarAnnotationsLock: "Vergrendelen",
  toolbarAnnotationsMeasurerAnnotations: "Meetinstrumenten",
  toolbarAnnotationsNote: "Notitie",
  toolbarAnnotationsParallelChannel: "Parallel Kanaal",
  toolbarAnnotationsPriceRange: "Prijscategorie",
  toolbarAnnotationsQuickDatePriceRange: "Meten",
  toolbarAnnotationsSettings: "Instellingen",
  toolbarAnnotationsShapeAnnotations: "Pijlen",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstanmerkingen",
  toolbarAnnotationsTextColor: "Tekstkleur",
  toolbarAnnotationsTextSize: "Tekstgrootte",
  toolbarAnnotationsTrendLine: "Trend Lijn",
  toolbarAnnotationsUnlock: "Ontgrendelen",
  toolbarAnnotationsVerticalLine: "Verticale lijn",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 maand",
  toolbarRange1Year: "1Jr",
  toolbarRange1YearAria: "1 jaar",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 maanden",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 maanden",
  toolbarRangeAll: "Alles",
  toolbarRangeAllAria: "Alles",
  toolbarRangeYearToDate: "JTD",
  toolbarRangeYearToDateAria: "Jaar tot nu toe",
  toolbarSeriesTypeCandles: "Kaarsen",
  toolbarSeriesTypeDropdown: "Grafiektype",
  toolbarSeriesTypeHighLow: "Hoog Laag",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hollow Kaarsen",
  toolbarSeriesTypeLine: "Lijn",
  toolbarSeriesTypeLineWithMarkers: "Lijn met Markers",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Stappenlijn",
  toolbarZoomPanEnd: "Naar het einde pannen",
  toolbarZoomPanLeft: "Links pannen",
  toolbarZoomPanRight: "Naar rechts pannen",
  toolbarZoomPanStart: "Scroll naar het begin",
  toolbarZoomReset: "Zoom resetten",
  toolbarZoomZoomIn: "Inzoomen",
  toolbarZoomZoomOut: "Uitzoomen",
  tooltipPaginationStatus: "${index}[number] van ${count}[number]"
};
//# sourceMappingURL=nl-NL.cjs.js.map
